import { Component, EventEmitter, Output } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import {
  HubtypeProviderAccount,
  WebchatSettings,
} from '../../../models/hubtype-provider-account'

@Component({
  selector: 'app-channels-webchat',
  templateUrl: './webchat.component.html',
  styleUrls: ['./webchat.component.scss'],
  standalone: false,
})
export class WebchatComponent {
  webchatChannelName = ''
  webchatSettings: WebchatSettings = {
    visible: true,
    scheduled_queue_id: null,
    whitelisted_urls: [],
  }

  get titleText(): string {
    return this.translate.instant('shared.addChannels.webchat.title')
  }
  get intro1Text(): string {
    return this.translate.instant('shared.addChannels.webchat.intro1')
  }
  get intro2Text(): string {
    return this.translate.instant('shared.addChannels.webchat.intro2')
  }
  get namePlaceholder(): string {
    return this.translate.instant('shared.addChannels.webchat.namePlaceholder')
  }
  get enableWebchatText(): string {
    return this.translate.instant('shared.addChannels.webchat.enableWebchat')
  }

  @Output() newChannel = new EventEmitter<HubtypeProviderAccount>()

  constructor(private translate: TranslateService) {}

  addWebchat() {
    const provider = new HubtypeProviderAccount()
    provider.provider = HubtypeProviderAccount.WEBCHAT
    provider.name = this.webchatChannelName
    provider.credentials_json = {}
    provider.credentials_json.settings = this.webchatSettings
    this.newChannel.emit(provider)
  }

  onWebchatSettingsChanged(updatedWebchatSettings: WebchatSettings) {
    this.webchatSettings = updatedWebchatSettings
  }
}
